import React from 'react';
import { useSelector } from 'react-redux';
import AutoSuggestionSelectComponent from 'src/Admin/components/common/AutoSuggestSelect/Select';
import './styles/options.scss';

const CustomAutoSuggestSelectOptions = ({
  options,
  formatOptionLabel,
  onChange,
  selectedCoverageData,
  setSelectedCoverageData,
}) => {
  const customStyles = ({ themeColors }) => {
    return {
      control: (provided) => {
        return {
          ...provided,
          height: '40px',
          minHeight: '40px',
          boxShadow: 'none',
          borderRadius: '5px',
          borderColor: themeColors?.['Secondary-Grey'],
          '&:hover': {
            borderColor: themeColors?.['Secondary-1'],
          },
          background: themeColors?.['Secondary-Background'],
        };
      },
      placeholder: (provided) => ({
        ...provided,
        fontSize: '14px',
        fontWeight: '400',
        color: themeColors?.['Secondary-Text'],
        fontFamily: themeColors?.['ParagraphFont'],
      }),
      singleValue: (provided) => ({
        ...provided,
        fontSize: '14px',
        fontWeight: '400',
        color: themeColors?.['Primary-Text'],
        fontFamily: themeColors?.['ParagraphFont'],
      }),
      option: (provided, state) => {
        const { isSelected, isFocused } = state;

        return {
          ...provided,
          fontSize: '16px',
          fontWeight: '400',
          fontFamily: themeColors?.['ParagraphFont'],
          borderBottom: `1px solid ${themeColors?.['Primary-Grey']}`,
          color: isSelected
            ? themeColors?.['Secondary-Background']
            : themeColors?.['Primary-Text'],
          backgroundColor: isSelected
            ? themeColors?.['Primary-Grey'] //added for custom dropdown option
            : isFocused
            ? `${themeColors?.['Secondary-2']}16`
            : 'transparent',
          '&:active': {
            color: themeColors?.['Secondary-Background'],
            backgroundColor: `${themeColors?.['Secondary-2']}`,
          },
        };
      },
      menu: (provided) => ({
        ...provided,
        marginTop: 0,
        borderWidth: '0 1px 1px',
        borderRadius: '0 0 5px 5px',
      }),
      menuList: (provided) => ({
        ...provided,
        paddingTop: 0,
        paddingBottom: 0,
      }),
    };
  };
  const themeColors = useSelector((state) => state.theme.themeValuesObject);
  const styles = customStyles({ themeColors });
  return (
    <AutoSuggestionSelectComponent
      options={options}
      formatOptionLabel={formatOptionLabel}
      components={{ IndicatorSeparator: () => null }}
      value={selectedCoverageData}
      onChange={(e) => {
        onChange(e);
        setSelectedCoverageData(e);
      }}
      isSearchable={false}
      inputClassName="height-32"
      onFocus={() => {}}
      styles={styles}
    />
  );
};

export default CustomAutoSuggestSelectOptions;
